import React, { useMemo, useState } from "react";
import { CheckOutlined, CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import SheriZeroCard from "assets/svg/sherizeroCard.svg";
import SheriCard from "assets/svg/sheriCard.svg";
import { useTranslation } from "contexts/TranslationContext";
import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLazyGetBusinessProviderAltQuery } from "services/lookup";
import BackButton from 'shared/components/BackButton/BackButton';
import routes, { appRoute } from 'shared/constants/routes';
import { Row, Col, Card, Button, Upload, Input, Form, Typography, Modal } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { FormDrawer, buildInitialValues, buildValidationSchema } from 'Components';
import * as Yup from "yup";
import { Formik, useFormikContext } from "formik";
import { useCreateNewAppMutation } from "services/auth";
import useAuthHook from "hooks/useAuthHook";
import { useUpdateAppDetailsMutation } from "services/auth";
import { toast } from "react-toastify";
import Arrow from 'assets/svg/arrow.svg'
import axios from "axios";
import env from "shared/constants/env";
import { useRef } from "react";
import SaudiRiyal from "assets/svg/saudi_riyal_symbol.svg";
import schoolAlhasa from "assets/svg/schoolAlhasa.svg";
import schoolAlKhobar from "assets/svg/schoolAlKhobar.svg";
import schoolAlRiyadh from "assets/svg/schoolAlRiyadh.svg";



const { Title, Text } = Typography;
const { Dragger } = Upload;



const SchoolProducts = () => {
    const { translate, language } = useTranslation();
    const [createNewApp, createNewAppStatus] = useCreateNewAppMutation();
    const [updateApplicationDetails, updateAppDetailsStatus] = useUpdateAppDetailsMutation();
    const { getUser } = useAuthHook();
    const navigate = useNavigate();
    const { id } = useParams()
    const [uploadFile, setUploadFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [isUploading, setIsUploading] = useState(false)
    const [tenureOptions, setTenureOptions] = useState([]);
    const formikRef = useRef(null);

    // const { values } = useFormikContext()

    const isArabic = language?.code === "ar" ? true : false;

    let isLoading = createNewAppStatus.isLoading || updateAppDetailsStatus.isLoading;

    const schoolDetails = [
        {
            id: 1,
            title: translate("HOME.SCHOOL_ALHASA"),
            description: "HOME.AUTO_DESC",
            image: schoolAlhasa,
            subDescription: "PRODUCTS.SCHOOL_DESC_SUB",
        },
        {
            id: 2,
            title: translate("HOME.SCHOOL_KHOBAR"),
            description: "HOME.AUTO_DESC",
            image: schoolAlKhobar,
            subDescription: "PRODUCTS.SCHOOL_DESC_SUB",
        },
        {
            id: 3,
            title: translate("HOME.SCHOOL_RIYADH"),
            description: "HOME.AUTO_DESC",
            image: schoolAlRiyadh,
            subDescription: "PRODUCTS.SCHOOL_DESC_SUB",
        },
    ]

    const schoolSchema = ({ hideRequestedLoanAmount = true, tenureOptions = [] }) => [
        {
            type: "number",
            key: "request_amount",
            label: "Requested_loan_amount",
            span: 24,
            required: !hideRequestedLoanAmount,
            disabled: hideRequestedLoanAmount,
            pattern: "^[0-9]*$",
            validation: Yup.number()
                .required("CANNOT_BE_EMPTY")
                .min(3500, "MUST_BE_ATLEAST_3500")
                .max(500000, "CANNOT_EXCEED_500000")
            // validation: Yup.number()
            //     .when('productId', (productId, schema) => {
            //         // const parsed = productId[0] ? JSON.parse(productId[0]) : null;
            //         // if (parsed && parsed.PRODUCTID === 328) {
            //         return schema.required("CANNOT_BE_EMPTY")
            //             .integer("MUST_BE_INTEGER")
            //             .min(2000, "MUST_BE_ATLEAST_2000")
            //             .max(50000, "CANNOT_EXCEED_50000")
            //         // }
            //         // return schema.notRequired();
            //     }),
        },
        {
            type: "select",
            key: "tenure",
            label: "Tenure",
            required: true,
            options: tenureOptions,
            // value: 4,
            span: 12,
            validation: Yup.string()
                .required("CANNOT_BE_EMPTY")
            // .when('request_amount', (request_amount, schema) => {
            //   if (request_amount >= 2500 && request_amount <= 5000) {
            //     return schema.test(
            //       'max1',
            //       'MAX_12_MONTHS',
            //       value => { return parseInt(value, 10) <= 4 }
            //     );
            //   } else if (request_amount >= 5001 && request_amount <= 20000) {
            //     return schema.test(
            //       'max2',
            //       'MAX_36_MONTHS',
            //       value => parseInt(value, 10) <= 8
            //     );
            //   } else if (request_amount >= 20001) {
            //     return schema.test(
            //       'max3',
            //       'MAX_60_MONTHS',
            //       value => parseInt(value, 10) <= 12
            //     );
            //   }
            //   return schema; // default case if none of the conditions are met
            // }),
        },
        {
            type: "number",
            key: "salesRef",
            label: "SalesRef",
            span: 12,
            required: false,
            max: 10,
            min: 8,
            maxLength: 10,
            minLength: 8,
            validation: Yup.string()
                .matches(/^\d{8,10}$/, "MUST_BE_BETWEEN_8_AND_10_DIGITS")

        },
        // { type: "number", key: "IBAN", label: "IBAN", span: 20, translation: 'REQUEST_DETAILS.IBAN' },
    ];

    const TenureUpdater = (props) => {

        const tenureOpt = useMemo(() => {
            // const amount = props.values?.request_amount;
            // if (amount <= 3500 && amount >= 5000) return [{ value: '6', label: '6' }, { value: '12', label: '12' }];
            // if (amount >= 10001 && amount <= 25000) return [{ value: '6', label: '6' }, { value: '12', label: '12' }, { value: '24', label: '24' }, { value: '36', label: '36' }];
            // if (amount >= 25001 && amount <= 500000) return [{ value: '6', label: '6' }, { value: '12', label: '12' }, { value: '24', label: '24' }, { value: '36', label: '36' }, { value: '48', label: '48' }, { value: '60', label: '60' }];

            return [{ value: '6', label: '6' }, { value: '8', label: '8' }, { value: '10', label: '10' }]
        }, [props.values?.request_amount]);

        let tenureSelectionCheck = tenureOpt.find(opt => opt.value === props.values?.tenure)
        if (tenureSelectionCheck === undefined && props.values?.tenure !== "") {
            props.setValues((prev) => ({
                ...prev,
                tenure: ""
            }))
        }

        setTenureOptions(tenureOpt);

        return null; // This component doesn't render anything directly
    };

    const VoucherAppSubmit = async (values, appId, idbUserId) => {
        values.productId = '330' //murhaba
        values.subproductId = '367'
        values.applStatus = 'S' //submitted

        switch (id) {
            case "1":
                values.dealerId = '2596083' //Al Hasa
                break;
            case "2":
                values.dealerId = '2596085' //Al Khobar
                break;
            case "3":
                values.dealerId = '2596087' //Al Riyadh
                break;
            default:
                return
        }

        const response = await updateApplicationDetails({
            appId: appId,
            userWebId: idbUserId,
            source: 'WEB',
            details: values,
        });
        if (response.error) {
            console.log("Error in update application", response.error);
            toast.error("Error in creating application");
            return
        }        if (response.data) {
            toast.success("Application Created Successfully");
            navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${appId}`, { replace: true });

        }
    }

    const VoucherAppCreate = async (values) => {
        try {
            const user = getUser();

            if (!user) return;

            const res = await createNewApp({
                id: String(user?.IDB_USR_ID),
                idNumber: String(user?.USER_ID),
                idType: String(user?.USER_ID)[0] === "1" ? "NID" : "Q",
            }).unwrap();
            if (res?.query) {
                handleUploadDocuments(fileList, res?.query);
                VoucherAppSubmit(values, res?.query, String(user?.IDB_USR_ID));
            }
        } catch (ex) {
            console.log("Error in create application", ex);
            toast.error("Error in creating application");
        }
    }

    const handleUploadDocuments = async (files, appId) => {
        setIsUploading(true);
        let updatedDocumentDetails = [...files];
        let allSuccess = true;
        await Promise.all(
            fileList.map(async (file, index) => {
                const formData = new FormData();
                formData.append("document", file);
                formData.append("appId", appId);
                const data = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));

                try {
                    await axios.post(`${env.API_ENDPOINT}app/upload-document`, formData, {
                        headers: {
                            Authorization: `Bearer ${data.token}`,
                        },
                    });
                    // Remove the file from the state after successful upload
                    updatedDocumentDetails.splice(index, 1);
                } catch (err) {
                    allSuccess = false;
                    toast.error("Failed to upload file.");
                }
            })
        )
        setIsUploading(false)
        // if (allSuccess) {
        //     toast.success("Application Created Successfully");
        //     navigate(appRoute(routes.HOME));
        // }
    }

    const beforeUpload = (file) => {
        const isJpgOrPngOrPdf =
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "application/pdf";
        if (!isJpgOrPngOrPdf) {
            toast.error(translate("SETTINGS.ERROR_FILE_TYPE"));
            return true;
        }

        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isLt3M) {
            toast.error(translate("SETTINGS.ERROR_FILE_SIZE_3MB"));
            return true;
        }

        const fileName = file.name;
        const multipleExtensionsPattern = /(\.[^.\s]{2,4}){2,}$/;
        if (multipleExtensionsPattern.test(fileName)) {
            toast.error(translate("SETTINGS.ERROR_FILE_MULTIPLE_EXT"));
            return true;
        }
        const invalidFileNamePattern = /^[^.]+\.[^.]+\..+\.[^.]+$/;

        if (invalidFileNamePattern.test(fileName)) {
            toast.error(translate("SETTINGS.ERROR_FILE_MULTIPLE_EXT"));
            return true;
        }

        if (fileName.toLowerCase().includes('contract')) {
            toast.error(translate("SETTINGS.ERROR_FILE_NAME_CONTRACT"));
            return true
        }
        setUploadFile(file)
        return false;
    };

    const validateFile = (file) => {
        const isValidType =
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "application/pdf";

        if (!isValidType) {
            return false;
        }

        const isUnder3MB = file.size / 1024 / 1024 < 3;
        if (!isUnder3MB) {
            return false;
        }

        const fileName = file.name;
        const multipleExtensionsPattern = /(\.[^.\s]{2,4}){2,}$/;
        if (multipleExtensionsPattern.test(fileName)) {
            return false;
        }

        const invalidFileNamePattern = /^[^.]+\.[^.]+\..+\.[^.]+$/;
        if (invalidFileNamePattern.test(fileName)) {
            return false;
        }

        if (fileName.toLowerCase().includes("contract")) {
            return false;
        }

        return true; // File is valid
    };

    const dragAndDropProps = {
        name: 'file',
        multiple: true,
        maxCount: 3,
        accept: "image/png,image/jpeg,image/jpg,application/pdf",
        beforeUpload,
        fileList,
        onChange(info) {
            if (info.file.status === 'error' || info.file.status === 'removed') {
                setFileList(prev => prev.filter(i => i.uid !== info.file.uid))
                return
            }
            const isValid = validateFile(info.file);
            if (isValid) {
                setFileList([...fileList, info.file])
                // dispatch({ type: PATCH_DOCUMENT_DETAILS, payload: [...fileList, info.file] });
            }
        },
        onDrop(e) {
            setFileList([e.dataTransfer.files])
        },
    };

    const handleRemove = (e) => {
        let updateFiles = fileList.filter(i => i.uid !== e.uid)
        // console.log('hi', updateFiles)
        // dispatch({ type: PATCH_DOCUMENT_DETAILS, payload: updateFiles });
        setFileList(prev => prev.filter(i => i.uid !== e.uid));
        setUploadFile(null)
    }

    const schemaFields = useMemo(
        () => {
            let hideRequestedLoanAmount = false;

            return schoolSchema({
                hideRequestedLoanAmount: hideRequestedLoanAmount,
                tenureOptions
            })
        },
        [tenureOptions]
    );

    const schoolCards = (school) => {
        return (
            <div
                className="w-full max-w-[450px] max-h[250px] overflow-hidden"
            >
                <div key={school.id} className="bg-[#E6F1F2] rounded-lg overflow-hidden flex flex-row">
                    <div className="p-6 flex flex-col justify-between flex-1">
                        <div>
                            <h3 className="text-[#1F225B] text-xl md:text-2xl font-light mb-2">{school.title}</h3>
                            <p className="text-[#8E9196] text-sm md:text-base mb-4">{translate(school.description)}</p>
                        </div>
                    </div>
                    <div className="md:w-2/5 sm:w-2/5 w-1/2">
                        <img src={school.image} alt={school.id} className="w-full h-full object-cover" />
                    </div>
                </div>

            </div>
        )
    }

    const schoolCardDetails = (school) => {
        return (
            <div
                bordered={false}
                className="bg-transparent shadow-none rounded-none border-none outline-none"
                style={{
                    width: '100%',
                    maxWidth: "550px",
                    // minHeight: "250px",
                    boxShadow: "none", // Remove shadow
                    border: "none",    // Remove border
                    borderRadius: "0", // Remove border-radius
                    outline: "none",
                    padding: "0"
                    // direction: 'ltr'

                }}
            >
                <p className="text-[#878787] mt-3 text-base md:text-lg font-light text-start mb-2">{translate(school.subDescription)}</p>

                {/* <ul className="mt-3">
                    {[
                        translate('PRODUCTS.AUTO_PT1'),
                        translate('PRODUCTS.AUTO_PT2'),

                        translate("PRODUCTS.AUTO_PT3"),
                        translate("PRODUCTS.AUTO_PT4"),
                        translate("PRODUCTS.AUTO_PT5"),
                        translate("PRODUCTS.AUTO_PT6"),
                        translate("PRODUCTS.AUTO_PT7"),
                        translate("PRODUCTS.AUTO_PT8"),
                    ].map((text, index) => (
                        <li className="flex mb-4 gap-2" key={index}>
                            <span className="flex-shrink-0">
                                <img src={Arrow} alt="checkmark" className="w-6 h-6" />
                            </span>
                            <span className="text-sm break-words">{text}</span>
                        </li>
                    ))}
                </ul> */}
            </div >
        )
    }

    return (
        <div className="rounded-xl mb-4 px-4 py-4 bg-white shadow-lg">
            <div className="p-5">
                {/* <Button onClick={() => navigate(-1)}>{translate("Back")}</Button> */}
                <BackButton onClick={() => navigate(-1)} />

                <Row gutter={[16, 16]} className="pt-4">
                    {/* Card Section */}
                    <Col xs={24} md={10}>
                        {(0 < Number(id) <= 3) && schoolCards(schoolDetails[Number(id) - 1])}
                        {0 < Number(id) <= 3 && schoolCardDetails(schoolDetails[Number(id) - 1])}
                    </Col>

                    {/* Form Section */}
                    <Col xs={24} md={14}>
                        <Formik
                            innerRef={formikRef}
                            validateOnChange={true}
                            validateOnMount={true}
                            initialValues={buildInitialValues(schemaFields)}
                            validationSchema={buildValidationSchema(schemaFields)}
                            onSubmit={(values) => VoucherAppCreate(values)}
                        >
                            {(props) => (
                                <Form onFinish={() => props.handleSubmit()}>
                                    {TenureUpdater(props)}
                                    <Title level={5} style={{ color: '#030438' }}>
                                        {translate('VOUCHERS.FILL_FORM')}
                                    </Title>
                                    <div>
                                        <FormDrawer schema={{ fields: schemaFields }} />
                                    </div>
                                    <div className="my-4">
                                        <label className="block text-gray-600 font-medium mb-2">
                                            {translate("SETTINGS.DOCUMENT")}
                                        </label>
                                        <Dragger
                                            {...dragAndDropProps} onRemove={e => handleRemove(e)}
                                            className="!border-none">
                                            <UploadOutlined className="text-3xl text-teal-600 mb-2" />
                                            <p className="text-teal-600 font-medium">
                                                {translate("SETTINGS.DOCUMENTS_DRAG_DROP_HEADING")}
                                            </p>
                                            <Text type="secondary" className="text-xs">
                                                {translate("SETTINGS.DOCUMENTS_DRAG_DROP_TEXT")}
                                            </Text>
                                        </Dragger>
                                    </div>

                                    <div className="flex justify-end mt-8">

                                        <Button disabled={!props.isValid} type="primary" htmlType="submit" className="mt-4 bg-primary border-none text-white font-semibold p-6 w-40" >
                                            {(isLoading || isUploading) ? <LoadingOutlined /> :
                                                translate("APPLY")}
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Col>
                </Row>
            </div>
        </div>

    )
}

export default SchoolProducts;